export const HOME = "/";
export const LOGIN_PATH = "/login";
export const LANDING = "/landing";
export const DASHBOARD = "/dashboard";
export const SEARCH = "/Search";
export const DOCDETAILS = "/DocDetails/:id/:docType";
export const CHECK_DETAILS = "/checkdetails/:docId/:vendorNo/:checkNo";
export const RESPONSE_DETAILS = "/responsedetails/:id";
export const NEW_REQUEST = "/request/:id?/:vendorNo?";
export const REQUESTINFO = "/requestInfo";
export const PASSWORD_CHANGE = "/change-password";
export const USERGUIDE = "/user-guide";
export const DOCUMENT_VIEW = "/daily-trial-balance/:id";
export const DOWNLOAD = "/download/:id/:name?";
export const COLLEAGUE_LOGIN_PATH = "/login?user_type=associate";
export const BASE_PATH = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
export const SUPPLIER_PATH = "/supplier";
export const VERIFY_SESSION_PATH = "/auth/verify-session";


